import { combineReducers } from 'redux'
import survey from './surveyPartition'
import { userData } from './UserData'
export default combineReducers({
  surveyDataFinal: survey,
  LogInUserData: userData
})